import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authService } from '../services';
import { useAuth } from '../context/AuthContext';
import PasswordStrengthChecklist from './auth/PasswordStrengthChecklist';
import { validatePassword } from '../utils/passwordValidator';
import './SignUp.css';

function SignUp() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [form, setForm] = useState({ name: '', email: '', company: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const passwordValidation = validatePassword(form.password);

  const onChange = (event) => {
    setForm((prev) => ({ ...prev, [event.target.name]: event.target.value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    if (!passwordValidation.isStrong) {
      setError('Defina uma senha forte para continuar.');
      return;
    }

    setLoading(true);

    try {
      const data = await authService.signup(form);
      if (!data?.success) {
        setError(data?.message || 'Falha ao cadastrar');
      } else {
        login(data);
        navigate('/home');
      }
    } catch (requestError) {
      setError('Erro de conexão');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signup-container">
      <div className="signup-shell">
        <aside className="signup-hero">
          <div className="signup-hero-overlay" />
          <div className="signup-hero-content">
            <span className="signup-hero-tag">Marketing PRO</span>
            <h1>Crie sua conta</h1>
            <p>Comece com fluxo modular e escalável.</p>
          </div>
        </aside>

        <section className="signup-panel">
          <header className="signup-header">
            <div className="logo-container">
              <img src="/logo-branca.png" alt="Marketing PRO" className="logo-image" />
            </div>
          </header>

          {error && <div className="error-message">{error}</div>}

          <form className="signup-form" onSubmit={handleSubmit}>
            <div className="input-group">
              <label htmlFor="name">Nome</label>
              <input id="name" name="name" value={form.name} onChange={onChange} required />
            </div>
            <div className="input-group">
              <label htmlFor="email">E-mail</label>
              <input id="email" name="email" type="email" value={form.email} onChange={onChange} required />
            </div>
            <div className="input-group">
              <label htmlFor="company">Empresa</label>
              <input id="company" name="company" value={form.company} onChange={onChange} />
            </div>
            <div className="input-group">
              <label htmlFor="password">Senha</label>
              <input id="password" name="password" type="password" value={form.password} onChange={onChange} required />
              <PasswordStrengthChecklist password={form.password} />
            </div>
            <button className="btn btn-outline btn-full" type="submit" disabled={loading || !passwordValidation.isStrong}>
              <span className="inner">{loading ? 'Criando...' : 'Criar conta'}</span>
            </button>
          </form>

          <footer className="signup-footer">
            <div className="login-link">
              Já tem conta? <Link to="/">Entrar</Link>
            </div>
          </footer>
        </section>
      </div>
    </div>
  );
}

export default SignUp;
